import React from 'react';
import './Services.css';

const ServicesHero = () => {
  return (
    <div className="services-hero">
      <div className='service-hero-img'>
      <div className="overlay"></div>
      <div className="hero-content">
        <h2 className='hero_heading'>SERVICES</h2>
        <p className='hero_subheading'>Delivering Reliable Services, Designed <br/>for Results</p>
      </div>
    </div>
    </div>
  );
};

export default ServicesHero;
